import { render, staticRenderFns } from "./OrganisationCards.vue?vue&type=template&id=37228d36&"
import script from "./OrganisationCards.vue?vue&type=script&lang=js&"
export * from "./OrganisationCards.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports